import AppAction from "@my-dld/actions";
import { Action } from "redux";
import { EjariProperty } from "@eres/ejari-api/Entity";
import { GetManagementContractDetails, MCContractDetails, MCPaymentDetails, OptionEJLookup } from "@eres/ejari-api/Entity/management_contract";
import { TenancyContactAction } from "../constants";

export interface ManagementContractDataState {
	action?: TenancyContactAction;
	id?: number;
	properties?: EjariProperty[];
	ogProperty?: EjariProperty;
	documents?: any[];
	contractDetail?: MCContractDetails;
	payments?: MCPaymentDetails[];
	responsibilities?: OptionEJLookup[];
	additionalTerms?: any[];
	isRefreshing?: boolean;
	managementContractDetails?: GetManagementContractDetails;
}

export const defaultState: ManagementContractDataState = {};

export enum ManagementContractDataAction {
	MANAGEMENT_CONTRACT_CLEAR_DATA = "MANAGEMENT_CONTRACT_CLEAR_DATA",
	MANAGEMENT_CONTRACT_UPDATE_PROPERTY = "MANAGEMENT_CONTRACT_UPDATE_PROPERTY",
	MANAGEMENT_CONTRACT_UPDATE_STATE = "MANAGEMENT_CONTRACT_UPDATE_STATE",
}

export type ManagementContractAction =
	Action<AppAction.USER_LOGGED_OUT> |
	Action<ManagementContractDataAction.MANAGEMENT_CONTRACT_CLEAR_DATA> |
	Action<ManagementContractDataAction.MANAGEMENT_CONTRACT_UPDATE_PROPERTY> & { payload?: EjariProperty } |
	Action<ManagementContractDataAction.MANAGEMENT_CONTRACT_UPDATE_STATE> & { payload?: Partial<ManagementContractDataState> };

export function ManagementContractDataReducer( state = defaultState, action: ManagementContractAction ) {
	switch ( action.type ) {
		case ManagementContractDataAction.MANAGEMENT_CONTRACT_CLEAR_DATA:
			return {
				...defaultState
			};
		case ManagementContractDataAction.MANAGEMENT_CONTRACT_UPDATE_PROPERTY:
			return {
				...state,
				property: action.payload,
			};
		case ManagementContractDataAction.MANAGEMENT_CONTRACT_UPDATE_STATE:
			return {
				...state,
				...action.payload,
			};

		case AppAction.USER_LOGGED_OUT:
			return { ...defaultState };
		default:
			return state;
	}
}
